import { useParams } from 'react-router';
import { useState } from 'react';

import CircularProgress from '@mui/material/CircularProgress';

import { useCollection, useCollectionConditionally, useDoc } from 'ember';
import { useAuthData } from 'stuff';
import { where } from 'firebase/firestore';
import { Certification, CertificationRecord } from 'models';

import CertificationDataProvider from './CertificationDataProvider';
import { Box, Icon, Stack, Typography } from '@mui/material';
import ButtonToOpenDialog from 'app/widgets/dialogs/ButtonToOpenDialog';
import CreateAction from '../actions/createAction/CreateAction';
import CertificationsListResponsiveContent from './CertificationsList';
import CreateCertificate from './CreateEditCertification';

import { useCertification } from './CertificationDataProvider';
import ComponentRecordForm from 'app/gizmos/component_record/ComponentRecordForm';

import CertificationsList from './CertificationsList';


const CertificationMainPage = () => 

{
	const [ closeDialog, setCloseDialog ] = useState<boolean>(false);
	
	const { claims } = useAuthData();
	
	
	//this has all the cert records 
	const certifications_collection_path = `organizations/${claims?.organization_id}/certifications`;
	
	//might break if empty? test 
	const certifications_collection = useCollection(certifications_collection_path);
	
	
	
	if(certifications_collection?.is_loading)
	{
		return <CircularProgress />
	}
	
	
	const certification_collections_data = certifications_collection?.data as Certification[] 
	console.log ({certification_collections_data})
	
	
	
	
	
	return (
		
		<CertificationDataProvider>
				
			<Box
			sx={{
				width: '100%',
				marginBottom: '30px'
			}}
			>
				<Stack
					flexDirection='column'
					justifyContent='center'
					alignItems='center'
					width='90%'
					spacing={2}
					sx={{
						margin: '10px',
					}}
				>
					
					<Typography
						variant='h3'
					>
						Certifications
					</Typography>
					
					
					<CertificationsList />
					
					<ButtonToOpenDialog
							button_variant='contained'
							dialog_title=''
							button_content='Create Certification'
							dialog_content={
								<CreateCertificate
									closeDialog={closeDialog}
									setCloseDialog={setCloseDialog}
								/>
							}
							closeDialog={closeDialog}
						/>
						
					
				</Stack>
				
			</Box>
			
			
			
		</CertificationDataProvider>
		
	)
	
	
	
}

export default CertificationMainPage